export default __webpack_public_path__ + "static/media/Minicard_9d.59b1fc2c.svg";